export const TRANSLATIONS_EN = {
  "routes_Pages": "Pages",
  "routes_Dashboard": "Dashboard",
  "routes_Questionnaire": "Standards",
  "routes_Stats": "Stats",
  "routes_Settings": "Settings",
  "routes_Resouces": "Resources",
  "routes_Contact": "Contact",
  "routes_Downloads": "Downloads",
  "routes_Documentation": "Documentation",
  "dashboard_welcome_message": "Welcome to Accessibility Management System Dashboard 👋",
  "dashboard_label": "All your accessibility data gathered, structured, and monitored in one place.",
  "gettingStartedCard_gettingStarted": "Getting Started",
  "gettingStartedCard_gettinStartedDescription": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam elementum dui nunc, ac porta sem consequat nec. Pellentesque",
  "gettingStartedCard_Steps": "We recommend these steps to start with:",
  "gettingStartedCard_step1": "Read the documentation",
  "gettingStartedCard_step2": "Download the Checklist",
  "gettingStartedCard_step3": "Check your statistics",
  "companyCard_supportedStandards": "Supported standards:",
  "companyCard_companyInformation": "Company Information",
  "companyCard_numberOfEmployees": "employees",
  "propertyListPage_propertyList": "Property List",
  "propertyListPage_dashboard": "Dashboard",
  "propertyListPage_Questionnaire": "Standards",
  "propertyListPage_newProperty": "New Property",
  "propertyListPage_textmapEdit": "Edit Property",
  "propertyListPage_textmapQuestionnaire": "Classify",
  "propertyListPage_textmapFacility": "Edit Facility",
  "propertyListPage_textmapNewProperty": "New Property",
  "propertyListPage_createNewProperty": "Create New Property",
  "propertyListPage_disabilityClassification": "Disability Classification",
  "propertyListPage_editProperty": "Edit Property",
  "propertyListPage_editFacilities": "Edit Facilities",
  "propertyListPage_classify": "Classify",
  "propertyListPage_search": "Search by property name",
  "propertyForm_propertyInformation": "1.1 Property Information",
  "propertyForm_standardType": "Standard Type",
  "propertyForm_fieldCannotBeChanged": "This field cannot be changed",
  "propertyForm_propertyCategory": "Property category",
  "propertyForm_typeOfProperty": "Type of Property",
  "propertyForm_propertyName": "Property Name",
  "propertyForm_propertyArea": "Amount of square meters of floor surface",
  "propertyForm_enterPropertyAddress": "1.1.2 Enter Property Address",
  "propertyForm_addressLocation": "Type the address location below",
  "propertyForm_mapNote": "If needed, you can adjust the map so the pin is in the right location",
  "propertyForm_keyPropertyData": "1.2 Key property data",
  "propertyForm_floorsQuestion": "How many floors does your property have?",
  "propertyForm_roomsQuestion": "How many rooms does your property have?",
  "propertyForm_disabledRoomsQuestion": "How many disabled rooms does your property have?",
  "propertyForm_alergyRoomsQuestion": "How many allergy rooms does your property have?",
  "propertyForm_save": "Save",
  "propertyForm_propertyHotelTypeOptionsLabel_Hotel": "Hotel",
  "propertyForm_propertyHotelTypeOptionsLabel_Motel": "Motel",
  "propertyForm_propertyConvenienceStoreOptions_Candies": "Candies",
  "propertyForm_propertyConvenienceStoreOptions_Newspapers": "Newspapers",
  "propertyForm_propertyConvenienceStoreOptions_TobaccoProducts": "Tabacco products",
  "propertyForm_propertyConvenienceStoreOptions_Toiletries": "Toiletries",
  "propertyForm_propertyConvenienceStoreOptions_Store": "Store",
  "propertyForm_propertyConvenienceStoreOptions_Supermarket": "Supermarket",
  "propertyForm_propertyDepartmentStoreOptions_Clothing": "Clothing",
  "propertyForm_propertyDepartmentStoreOptions_DepartmentStore": "Department_store",
  "propertyForm_propertyDepartmentStoreOptions_Electronics": "Electronics",
  "propertyForm_propertyDepartmentStoreOptions_Garden": "Garden",
  "propertyForm_propertyDepartmentStoreOptions_Household_goods": "Household_goods",
  "propertyForm_propertyDepartmentStoreOptions_Pets": "Pets",
  "propertyForm_propertyDepartmentStoreOptions_Toys": "Toys",
  "propertyForm_propertyFoodAndDrinkOptions_bakery_and_baked_goods_store": "Bakery and baked goods store",
  "propertyForm_propertyFoodAndDrinkOptions_dairy_goods": "Dairy goods",
  "propertyForm_propertyFoodAndDrinkOptions_food_and_drink": "Food and drink",
  "propertyForm_propertyFoodAndDrinkOptions_food_beverage_specialty_store": "Food beverage specialty store",
  "propertyForm_propertyFoodAndDrinkOptions_grocery": "Grocery",
  "propertyForm_propertyFoodAndDrinkOptions_meat": "Meat",
  "propertyForm_propertyFoodAndDrinkOptions_specialty_food_store": "Specialty food store",
  "propertyForm_propertyFoodAndDrinkOptions_Vegan": "Vegan",
  "propertyForm_propertyFoodAndDrinkOptions_Vegetarian": "Vegetarian",
  "propertyForm_propertyFoodAndDrinkOptions_wine_and_liquor": "Wine and liquor",
  "propertyForm_propertyDrugstoreOptions_drugstore": "Drugstore",
  "propertyForm_propertyDrugstoreOptions_pharmacy": "Pharmacy",
  "propertyForm_propertyElectronicsOptions_computer_and_software": "Computer and software",
  "propertyForm_propertyElectronicsOptions_consumer_electronics_store": "Consumer electronics store",
  "propertyForm_propertyElectronicsOptions_electronics": "Electronics",
  "propertyForm_propertyElectronicsOptions_entertainment_electronics": "Entertainment_electronics",
  "propertyForm_propertyElectronicsOptions_mobile_retailer": "Mobile retailer",
  "propertyForm_propertyElectronicsOptions_mobile_service_center": "Mobile service center",
  "propertyForm_propertyMallOptions_shopping_gallery_mall": "Shopping gallery mall",
  "propertyForm_propertyMallOptions_shopping_mall": "Shopping mall",
  "propertyForm_standardTypeOptions_hotel_motel": "Hotel\/Motel",
  "propertyForm_standardTypeOptions_shopping_mall": "Shopping Mall",
  "propertyForm_standardTypeOptions_shop": "Shop",
  "propertyForm_propertyHardwareOptions_floor_and_carpet": "Floor and carpet",
  "propertyForm_propertyHardwareOptions_furniture_store": "Furniture store",
  "propertyForm_propertyHardwareOptions_garden_center": "Garden center",
  "propertyForm_propertyHardwareOptions_glass_and_window": "Glass and window",
  "propertyForm_propertyHardwareOptions_hardware_house_garden": "Hardware house garden",
  "propertyForm_propertyHardwareOptions_home_improvement_hardware_store": "Home improvement hardware store",
  "propertyForm_propertyHardwareOptions_home_specialty_store": "Home specialty store",
  "propertyForm_propertyHardwareOptions_lumber": "Lumber",
  "propertyForm_propertyHardwareOptions_major_appliance": "Major appliance",
  "propertyForm_propertyHardwareOptions_paint_store": "Paint store",
  "propertyForm_propertyHardwareOptions_power_equipment_dealer": "Power equipment dealer",
  "propertyForm_propertyBookstoreOptions_bookstore": "Bookstore",
  "propertyForm_propertyClothingOptions_childrens_apparel": "Childrens apparel",
  "propertyForm_propertyClothingOptions_clothing_and_accessories": "Clothing and accessories",
  "propertyForm_propertyClothingOptions_mens_apparel": "Mens apparel",
  "propertyForm_propertyClothingOptions_shoes_footwear": "Shoes footwear",
  "propertyForm_propertyClothingOptions_specialty_clothing_store": "Specialty clothing store",
  "propertyForm_propertyClothingOptions_womens_apparel": "Womens apparel",
  "propertyForm_consumerGoodsOptions_adult_shop": "Adult shop",
  "propertyForm_consumerGoodsOptions_arts_and_crafts_supplies": "Arts and crafts supplies",
  "propertyForm_consumerGoodsOptions_bicycle_and_bicycle_accessories_shop": "Bicycle and bicycle accessories shop",
  "propertyForm_consumerGoodsOptions_camping_hiking_shop": "Camping hiking shop",
  "propertyForm_consumerGoodsOptions_canoe_kayak_shop": "Canoe kayak shop",
  "propertyForm_consumerGoodsOptions_car_accessories": "Car accessories",
  "propertyForm_consumerGoodsOptions_consumer_goods": "Consumer goods",
  "propertyForm_consumerGoodsOptions_cross_country_ski_shop": "Cross country ski shop",
  "propertyForm_consumerGoodsOptions_florist": "Florist",
  "propertyForm_consumerGoodsOptions_general_merchandise": "General merchandise",
  "propertyForm_consumerGoodsOptions_gift_antique_art": "Gift antique art",
  "propertyForm_consumerGoodsOptions_hobby_store": "Hobby store",
  "propertyForm_consumerGoodsOptions_hunting_fishing_shop": "Hunting fishing shop",
  "propertyForm_consumerGoodsOptions_jeweler": "Jeweler",
  "propertyForm_consumerGoodsOptions_market": "Market",
  "propertyForm_consumerGoodsOptions_motorcycle_accessories": "Motorcycle accessories",
  "propertyForm_consumerGoodsOptions_non_store_retailers": "Non store retailers",
  "propertyForm_consumerGoodsOptions_office_supply_store": "Office supply store",
  "propertyForm_consumerGoodsOptions_pawnshop": "Pawnshop",
  "propertyForm_consumerGoodsOptions_pet_supply": "Pet supply",
  "propertyForm_consumerGoodsOptions_record_cd_video": "Record cd video",
  "propertyForm_consumerGoodsOptions_running_walking_shop": "Running walking shop",
  "propertyForm_consumerGoodsOptions_skate_shop": "Skate shop",
  "propertyForm_consumerGoodsOptions_ski_snowboard_shop": "Ski snowboard shop",
  "propertyForm_consumerGoodsOptions_specialty_store": "Specialty store",
  "propertyForm_consumerGoodsOptions_sporting_goods_store": "Sporting goods store",
  "propertyForm_consumerGoodsOptions_surf_shop": "Surf shop",
  "propertyForm_consumerGoodsOptions_tack_shop": "Tack shop",
  "propertyForm_consumerGoodsOptions_toy_store": "Toy store",
  "propertyForm_consumerGoodsOptions_used_second_hand_merchandise_stores": "Used second hand merchandise stores",
  "propertyForm_consumerGoodsOptions_variety_store": "Variety store",
  "propertyForm_consumerGoodsOptions_video_and_game_rental": "Video and game rental",
  "propertyForm_consumerGoodsOptions_warehouse_wholesale_store": "Warehouse wholesale store",
  "propertyForm_hairAndBeautyOptions_barber": "Barber",
  "propertyForm_hairAndBeautyOptions_hair_and_beauty": "Hair and beauty",
  "propertyForm_hairAndBeautyOptions_hair_salon": "Hair salon",
  "propertyForm_hairAndBeautyOptions_nail_salon": "Nail salon",
  "propertyForm_hairAndBeautyOptions_make_up_salon": "Make up salon",
  "propertyForm_mallTopCategoryOptions_mall_shopping_complex": "Mall shopping complex",
  "propertyForm_accomodationsCategoryOptions_hotel_motel": "Hotel\/Motel",
  "propertyForm_shopCategoryOptions_convenience_store": "Convenience store",
  "propertyForm_shopCategoryOptions_department_store": "Department store",
  "propertyForm_shopCategoryOptions_food_and_drink": "Food and drink",
  "propertyForm_shopCategoryOptions_drugstore_or_pharmacy": "Drugstore or pharmacy",
  "propertyForm_shopCategoryOptions_electronics": "Electronics",
  "propertyForm_shopCategoryOptions_hardware_house_garden": "Hardware house garden",
  "propertyForm_shopCategoryOptions_bookstore": "Bookstore",
  "propertyForm_shopCategoryOptions_clothing_and_accessories": "Clothing and accessories",
  "propertyForm_shopCategoryOptions_consumer_goods": "Consumer goods",
  "propertyForm_shopCategoryOptions_hair_and_beauty": "Hair and beauty",
  "facilitiesForm_standardTypeOptions_hotel_motel": "Hotel\/Motel",
  "facilitiesForm_standardTypeOptions_office": "Office",
  "facilitiesForm_standardTypeOptions_shopping_mall": "Shopping mall",
  "facilitiesForm_standardTypeOptions_shop": "Shop",
  "facilitiesForm_selectFacilitiesForDataCollection": "2. Select facilities for data collection",
  "facilitiesForm_preselectedMandatoryItems": "The following preselected items are Mandatory",
  "facilitiesForm_mandatoryFacilitiesFor": "Mandatory Facilities for",
  "facilitiesForm_optionalFacilitiesFor": "Optional Facilities for",
  "facilitiesForm_standard": "Standard",
  "facilitiesForm_preselectedOptionalItems": "The following items are optional",
  "facilitiesForm_faq_mandatoryFacilities": "What are mandatory facilities?",
  "facilitiesForm_faq_AnswerMandatoryFacilities": "Those are standard facilities that we find in properties of your kind. To generate our accessibility data in a thorough way, these facilities must be assessed. EX the entrance of the building",
  "facilitiesForm_faq_optionalFacilities": "What are optional facilities?",
  "facilitiesForm_faq_AnswerOptionalFacilities": "This is a non-exhaustive list of facilities that might exist or not in your property, but that are not necessarily standard facilities in a property like yours. For example, a Spa in a hotel or in a Shopping Mall.",
  "unitForm_helperText_entrance_key": "Entrance",
  "unitForm_helperText_entrance_value": "i.e. Main Entrance or Secondary Entrances such as via Restaurant or Gardens",
  "unitForm_helperText_lobby_key": "Lobby",
  "unitForm_helperText_lobby_value": "i.e. Main lobby of property including lounge or waiting area",
  "unitForm_helperText_reception_key": "Reception\/info desk",
  "unitForm_helperText_reception_value": "i.e. Main Check-In Desk, Concierge Desk, Luggage Storage area or Information Desk areas",
  "unitForm_helperText_facility_key": "Facility",
  "unitForm_helperText_facility_value": "",
  "unitForm_helperText_parking_key": "Parking and near surroundings",
  "unitForm_helperText_parking_value": "i.e. Main Parking area and additional outside areas such as Gardens, Driveways, Walkways",
  "unitForm_helperText_commonAreas_key": "Common areas",
  "unitForm_helperText_commonAreas_value": "Shared public areas of the hotel such as Lobby Lounge, Corridors etc.",
  "unitForm_helperText_conferenceRoom_key": "Conference room \/ meeting room",
  "unitForm_helperText_conferenceRoom_value": "",
  "unitForm_helperText_auditorium_key": "Auditorium",
  "unitForm_helperText_auditorium_value": "Theatre Style space, Cinema etc.",
  "unitForm_helperText_diningArea_key": "Dining area",
  "unitForm_helperText_diningArea_value": "e.g Main restaurant, Breakfast Buffet area, Lobby Bar \/ Bistro",
  "unitForm_helperText_toiletRoom_key": "Toilet room (common, shared)",
  "unitForm_helperText_toiletRoom_value": "i.e. Shared Toilet \/ Bathroom accessible from Lobby, Restaurant or other public areas",
  "unitForm_helperText_gym_key": "Gym",
  "unitForm_helperText_gym_value": "",
  "unitForm_helperText_spa_key": "Spa",
  "unitForm_helperText_spa_value": "",
  "unitForm_helperText_hospitalityRoom_key": "Hospitality room type",
  "unitForm_helperText_hospitalityRoom_value": "i.e. Type of room, e.g. Single, Double, Accessible, Family etc",
  "unitForm_quantityLabel": "Select quantity",
  "unitForm_locationFaq": "Where is it located?",
  "unitForm_totalQuantity": "Total Quantity",
  "unitForm_floorSelection": "Select floor",
  "unitForm_finishedCreation": "Are you done creating units?",
  "unitForm_startClassifying": "Questionnaireing!",
  "unitForm_unitData2": "Private Toilet",
  "unitForm_unitData3": "Private Bathroom",
  "unitForm_unitData4": "Private Kitchen",
  "unitForm_unitTypeDetails": "3. Unit Type Details:",
  "unitForm_unitName": "Write your unit name here",
  "unitForm_accessibleUnit": "This unit is considered accessible",
  "questionUnits_addNewUnit": "Add new unit",
  "questionUnits_savedInfo": "Your info was saved",
  "questionUnits_removedInfo": "Your info was removed",
  "questionUnits_resources": "Resources",
  "questionUnits_uploadPictures": "Upload Pictures",
  "questionUnits_explanation": "Some explanation \/ details about this section can go here",
  "questionUnits_uploadLabel": "UPLOAD",
  "questionUnits_unitExtraInfo": "Unit Extra Info",
  "questionUnits_unitExtraInfoPlaceholder1": "Here you can insert private comments to this specific unit",
  "questionUnits_unitExtraInfoPlaceholder2": "( currently you have no comments on this unit )",
  "questionUnits_beforeClassification": "You should add facilities before starting to classify",
  "questionUnits_editFacilities": "Edit Facilities",
  "questionUnits_addNew": "Click on ‘Add New’ or select unit to start classifying",
  "questionUnits_faq1": "Info",
  "questionUnits_faq2": "What are mandatory facilities?",
  "questionUnits_faq2_1": "Those are standard facilities that we find in properties of your kind. To generate our accessibility data in a thorough way, these facilities must be assessed. EX the entrance of the building",
  "questionUnits_faq3": "What are optional facilities?",
  "questionUnits_faq3_1": "This is a non-exhaustive list of facilities that might exist or not in your property, but that are not necessarily standard facilities in a property like yours. For example, a Spa in a hotel or in a Shopping Mall.",
  "FAR_SelectProperty": "Select Property",
  "FAR_DocumentPreview": "Document preview:",
  "FAR_DownloadPDF": "Download PDF:",
  "FAR_Download": "Download now!",
  "CLP_SelectProperty": "Select Property",
  "CLP_SelectPropertyForChecklist": "Select a Property to create the Checklist",
  "CLP_AccessibilityChecklist": "Accessibility Checklist",
  "CLP_GeneratedOn": "Generated on ",
  "CLP_GeneratedBy": "Generated by ",
  "CLP_LoadingDoc": "Loading document...",
  "CLP_DownloadNow": "Download Now!",
  "A11yUnitsPageSubTitle": "Things to keep in mind",
  "A11yUnitsPageDescription": "You can only associate units similar to each other if they`re exactly the same. Otherwise another unit type should be created.",
  "routes_NewProperty": "New Property",
  "routes_EditProperty": "Edit Property",
  "routes_EditFacility": "Edit Facility",
  "routes_SelectFacilities": "Select Facilities",
  "routes_CreateProperty": "Create property",
  "routes_Classify": "Classify",
  "routes_Blank": "Blank",
  "changePassword_success": "Success",
  "changePassword_successMessage": "Your password has been updated",
  "changePassword_returnToLogin": "Return to Login",
  "changePassword_resetPassword": "Reset Your Password",
  "changePassword_newPassword_label": "New Password",
  "changePassword_confirmNewPassword_label": "Confirm New Password",
  "changePassword_newPasswordRequired_errorMessage": "New Password is required",
  "changePassword_newPasswordMismatch_errorMessage": "Passwords must match",
  "changePassword_newPassword_browserTab": "Change Password",
  "DocumentationPage_pageTitle": "Documentation Page",
  "DocumentationPage_tabtitle": "Documentation",
  "DownloadsPage_pageTitle": "Downloads Page",
  "LanguagesDropdown_English": "English",
  "LanguagesDropdown_French": "French",
  "LanguagesDropdown_German": "German",
  "LanguagesDropdown_Dutch": "Dutch",
  "LocationAutocomplete_searchPlaceholder": "Search Places ...",
  "LocationAutocomplete_validAddress": "Please indicate house number and street",
  "LocationAutocomplete_addressEmpty": "Address cannot be empty",
  "page404_PageNotFound": "Page not found.",
  "page404_PageNotFound_explanation": "The page you are looking for might have been removed.",
  "page404_PageNotFound_returnHome_button": "Return to website",
  "page500_InternalError": "Internal server error.",
  "page500_InternalError_explanation": "The server encountered something unexpected that did not allow it to complete the request.",
  "propertyListPage_NotClassified": "Not Classified",
  "propertyListIconName_allergy_food_class": "Allergy Food Class",
  "propertyListIconName_allergy_room_class": "Allergy Room Class",
  "propertyListIconName_mobility_class": "Mobility Class",
  "propertyListIconName_hearing_class": "Hearing Class",
  "propertyListIconName_cognitive_class": "Cognitive Class",
  "propertyListIconName_visual_class": "Visual Class",
  "propertyForm_AllStepsCompleted": "All steps completed",
  "propertyForm_propertyReady": "Your property is now ready!",
  "propertyForm_propertyReady_description": "You have finished your property information step. You can edit this information by clicking on Properties List link on the top left panel.",
  "propertyForm_startClassifying": "START CLASSIFYING",
  "propertyForm_propertyStepper_step1": "Add Property Information",
  "propertyForm_propertyStepper_step2": "Select Facilities",
  "propertyForm_propertyStepper_step3": "Add Unit Details",
  "settingsForms_CompanyInformation_SelectOptions_Service": "Service",
  "settingsForms_CompanyInformation_SelectOptions_Merchandising": "Merchandising",
  "settingsForms_CompanyInformation_SelectOptions_Manufacturing": "Manufacturing",
  "settingsForms_CompanyInformation_SelectOptions_Other": "Other",
  "settingsForms_ImageCantBeChanged": "This image can't be changed",
  "settingsForms_RegNumber_label": "Reg Number",
  "settingsForms_InvoiceStatus_label": "Invoice Status",
  "settingsForms_CompanyName_label": "Company Name",
  "settingsForms_CompanyType_label": "Company Type",
  "settingsForms_CompanySize_label": "Company Size",
  "settingsForms_CompanyAddress_label": "Company Address",
  "settingsForms_ContractDate_label": "Date of contract signing",
  "settingsForms_SubscriptionPeriod_label": "Subscription Period",
  "settingsForms_Employees_label": "Employees",
  "settingsForms_UserInformation_positionOptions_owner": "Owner",
  "settingsForms_UserInformation_positionOptions_executive": "Executive",
  "settingsForms_UserInformation_positionOptions_manager": "Manager",
  "settingsForms_UserInformation_positionOptions_operations_and_production": "Operations and production",
  "settingsForms_UserInformation_positionOptions_other": "Other",
  "settingsForms_UserInformation_departmentOptions_it": "IT",
  "settingsForms_UserInformation_departmentOptions_marketing": "Marketing",
  "settingsForms_UserInformation_departmentOptions_finance": "Finance",
  "settingsForms_UserInformation_departmentOptions_human_resources": "Human resources",
  "settingsForms_UserInformation_departmentOptions_sales": "Sales",
  "settingsForms_UserInformation_departmentOptions_operations": "Operations",
  "settingsForms_UserInformation_departmentOptions_other": "Other",
  "settingsForms_UserInformation_title": "User Information",
  "settingsForms_UserInformation_UploadPicture": "Upload Picture",
  "settingsForms_UserInformation_formatRestriction": "Use an image at least 128px by 128px in .jpg format",
  "settingsForms_UserInformation_surname": "Surname",
  "settingsForms_UserInformation_position": "Position",
  "settingsForms_UserInformation_department": "Department",
  "settingsPage_pageTitle": "Settings Page",
  "settingsPage_breadcrumbs_dashboard": "Dashboard",
  "settingsPage_breadcrumbs_settings": "Settings",
  "signinForm_explanation": "Sign in to your account to continue",
  "signinForm_validEmail_error": "Must be a valid email",
  "signinForm_emailRequired": "Email is required",
  "signinForm_generalError": "Something went wrong",
  "signinForm_passwordRequired": "Password is required",
  "signinForm_emailLabel_textfield": "Email Address",
  "signinForm_passwordLabel_textfield": "Password",
  "signinForm_remberMeCheckbox_textfield": "Remember me",
  "signinForm_signIn_button": "Sign in",
  "signinForm_forgotPassword_button": "Forgot password",
  "signupForm_signUp_button": "Sign Up",
  "signupForm_signUp_title": "Get started",
  "signupForm_signUp_subTitle": "Start creating the best possible user experience for your customers",
  "signupForm_signUp_nameRequired": "Name is required",
  "signupForm_signUp_minCharacters_errorMessage": "Must be at least 12 characters",
  "signupForm_signUp_required_errorMessage": "Required",
  "signupForm_signUp_nameLabel": "Name",
  "signupForm_signUp_companyLabel": "Company",
  "signupForm_signUp_emailAddressLabel": "Email Address",
  "signupForm_signUp_passwordLabel": "Password",
  "signupForm_signUp_confirmPasswordLabel": "Confirm Password",
  "statsPage_pageTitle": "Stats Page",
  "statsPage_cardContent": "This page will be available in future versions of the Accessibility Management System.",
  "resetPassword_inbox": "Check your inbox",
  "resetPassword_explanation_1": "We've sent an email to",
  "resetPassword_explanation_2": "with password restore instructions",
  "resetPassword_title": "Reset Password",
  "resetPassword_subTitle": "Enter your email to reset your password",
  "unitForm_title": "Composite Units",
  "unitForm_floorTitle": "Floor",
  "unitImagesDialog_labelMANDATORY": "MANDATORY",
  "unitImagesDialog_labelOPTIONAL": "OPTIONAL",
  "unitImagesDialog_labelPICTURES": "PICTURES",
  "unitImagesDialog_dropzone": "Drop pictures here or choose a file",
  "userDropdown_profile": "Profile",
  "userDropdown_signout": "Sign out",
  "questionUnits_uploadPictures_uploadError": "An error occurred while uploading the pictures",
  "questionUnits_uploadSuccess": "Your data has been submitted successfully",
  "questionUnits_unitExtraInfoLabel": "Extra Info",
  "questionUnits_unitExtraInfoDelete_button": "Delete",
  "questionUnits_unitExtraInfoSave_button": "Save",
  "QuestionnaireCompletionCard_title": "Standards Completion",
  "QuestionnaireCompletionCard_disableMessage": "You don`t have any classification yet.",
  "QuestionnaireCompletionCard_ParkingCard": "Parking",
  "QuestionnaireCompletionCard_EntranceCard": "Entrance",
  "QuestionnaireCompletionCard_ToiletCard": "Toilet",
  "QuestionnaireCompletionCard_RoomsCard": "Rooms",
  "QuestionnaireCompletionCard_LiftAndElevatorsCard": "Lift and Elevators",
  "QuestionnaireCompletionCard_LobbyAndReceptionCard": "Lobby and Reception",
  "FAR_Report": "Accessibility Report",
  "FAR_TableUnitName": "Unit Name",
  "FAR_TableDescription": "Description",
  "CLP_PleaseSelectProperty": "Please select property",
  "CLP_BrowserTabTitle": "Full Accessibillity Report ",
  "CLP_UnitMandatoryLabel": "Mandatory",
  "CLP_UnitDoneLabel": "DONE",
  "propertyPage_Controllers_SearchDoc": "Search Documentation",
  "generalWords_Yes": "Yes",
  "generalWords_No": "No",
  "generalWords_Next": "Next",
  "generalWords_Close": "Close",
  "generalWords_Reset": "Reset",
  "generalWords_Back": "Back",
  "generalWords_Finish": "Finish",
  "generalWords_NextStep": "Next Step",
  "generalWords_Edit": "Edit",
  "generalWords_Download": "Download",
  "generalWords_Delete": "Delete",
  "generalWords_SaveChanges": "Save Changes",
  "generalWords_Selected": "selected",
  "generalWords_Required": "Required",
  "customerSupportPage_title": "Customer Support Page",
  "customerSupportPage_emailLabel": "Contact customer support at:",
  "unitForm_helperText_entrance": "i.e. Main Entrance or Secondary Entrances such as via Restaurant or Gardens.",
  "unitForm_helperText_lobby": "i.e. Main lobby of property including lounge or waiting area.",
  "unitForm_helperText_reception": "i.e. Main Check-In Desk, Concierge Desk, Luggage Storage area or Information Desk areas.",
  "unitForm_helperText_facility": "i.e The name of the facility or property.",
  "unitForm_helperText_parking": "i.e. Main Parking area and additional outside areas such as Gardens, Driveways, Walkways.",
  "unitForm_helperText_conferenceRoom": "A conference room is a large room where a number of people can have a conference.",
  "unitForm_helperText_auditorium": "Theatre Style space, Cinema etc.",
  "unitForm_helperText_diningArea": "e.g Main restaurant, Breakfast Buffet area, Lobby Bar \/ Bistro.",
  "unitForm_helperText_toiletRoom": "i.e. Shared Toilet \/ Bathroom accessible from Lobby, Restaurant or other public areas.",
  "unitForm_helperText_gym": "Physical exercises and activities performed inside, often using equipment.",
  "unitForm_helperText_spa": "Place where one can relax through a sauna, pool and jacuzzi.",
  "unitForm_helperText_hospitalityRoom": "i.e. Type of room, e.g. Single, Double, Accessible, Family etc.",
  "unitForm_helperText_shopping_aisle": "i.e. aisle between the shelves.",
  "unitForm_helperText_counter": "A level surface (such as a table, shelf or display case) over which transactions are conducted.",
  "unitForm_helperText_checkout_pay": "e.g Checkout, Self checkout, Self-scanning checkout.",
  "unitForm_helperText_fitting_room": "A room in a store in which customers can put on a piece of clothing to see if it fits before they buy it.",
  "unitForm_helperText_manned_kiosk": "A cash exchange or redemption terminal, which allows for cash and cashless transactions with a cashier.",
  "unitForm_helperText_floor": "i.e The accessibility on different levels such as Lift on 1 floor, Green lift at entrance 2.",
  "unitForm_helperText_playground": "An area used by children to play in. They usually have equipment such as slides, swings and seesaws for children to play on.",
  "unitForm_helperText_garden": "A space, usually outdoors, set aside for the cultivation, display, and enjoyment of plants and other forms of nature.",
  "unitForm_helperText_bathroom_common": "A room containing a bathtub or shower and usually a sink and toilet.",
  "unitForm_helperText_bathroom__private": "A private room containing a bathtub or shower and usually a sink and toilet.",
  "unitForm_helperText_quiet_room": "A quiet room or silent room is a room built with regard to silence by shielding noise from or towards the surroundings.",
  "unitForm_helperText_kitchen_common": "A public room where one can prepare and cook food.",
  "unitForm_helperText_toilet_room__private": "i.e. private toilet accessible from lobby, restaurant or other public areas.",
  "unitForm_helperText_kitchen__private": "A private room where one can prepare and cook food.",
  "unitForm_helperText_conferenceRoom_": "",
  "routes_Services": "Services",
  "routes_Help": "Help",
  "routes_Clp": "Checklist",
  "routes_Far": "Accessibility Report",
  "FAR_WhatIsItTitle": "What is an Accessibility Report?",
  "FAR_WhatIsItDescription": "The Accessibility report is a report that we generate for you depending on how accessible your property is. Below you can select a property and download its PDF report.",
  "FAR_MoreInfo": "For more information about the Accessibility Report please",
  "FAR_SelectPropertyForChecklist": "Select a property to create the report",
  "CLP_noChecklistFound": "We couldn't find a list for this property",
  "CLP_WhatIsItTitle": "What is a checklist?",
  "CLP_WhatIsItDescription": "The Checklist is a list based on the Accessibility System inventory information. It shows the areas of improvement, based on your input in the system. A preview of the document is available and can be downloaded or printed.",
  "CLP_MoreInfo": "For more information about the Checklist please",
  "CLP_FAR_ConsultTheDocumentation": "consult the documentation",
  "LanguagesDropdown_Swedish": "Swedish",
  "LanguagesDropdown_Danish": "Danish",
  "gettingStartedCard_step1_link": "Read",
  "gettingStartedCard_step2_link": "Download",
  "gettingStartedCard_step3_link": "Check",
  "contactForm_category": "Category",
  "contactForm_title": "Contact us",
  "contactForm_chooseImg": "Choose image",
  "contactForm_submitBtn": "Send request",
  "contactForm_attachBtnLabel": "If possible, please attach a screenshot.",
  "contactForm_messageLabel": "Please describe your request here.",
  "contactForm_messageEmptyError": "Please add a message",
  "contactForm_categoryOptions_ServiceInquiry": "Service inquiry",
  "contactForm_categoryOptions_TechnicalIssues": "Technical issues",
  "contactForm_categoryOptions_OtherInquires": "Other inquiries",
  "contactForm_subtitle1": "If you can't find the answer you're looking for, we're here to lend a hand.",
  "contactForm_subtitle2": "Please write to us! We will get back to you as soon as possible.",
  "FAR_noDataAvalible_1": "Accessibility report can't be generated yet for this property. Please complete the",
  "FAR_noDataAvalible_2": "for",
  "FAR_noDataAvalible_3": "first.",
  "CLP_Updating": "Updating...",
  "CLP_AreYouSure": "Are you sure?",
  "CLP_UpdateMessage": "If you do this, the item will disappear from the checklist and the standard will be automatically updated reflecting the change.",
  "CLP_Cancel": "CANCEL",
  "CLP_YesUpdate": "YES, UPDATE",
  "CLP_WhatIsAChecklist": "What is a checklist?",
  "CLP_Name": "Name",
  "CLP_pdfDisclaimer": "Note: Once you do the improvements, don’t forget to update your accessibility data in the standard section.",
  "CLP_FAR_noAccessibilityDataAvailable1": "We don't have any accessibility data available. ",
  "CLP_noChecklist1": "The checklist can’t be generated yet for this property. Answer the questions inside the ",
  "CLP_noChecklist2": "standard section ",
  "CLP_noChecklist3": "for",
  "CLP_noChecklist4": "first.",
  "CLP_FAR_noAccessibilityDataAvailable2": "Create a property",
  "CLP_FAR_noAccessibilityDataAvailable3": " and answer the questions inside the standard section first.",
  "statsPage_subscriptionExpiring": "Subscription expiring in",
  "statsPage_days": "days",
  "statsPage_contactCustomerSupport": "Contact Customer Support",
  "statsPage_companyInformation": "Company information",
  "statsPage_numberOfPhotosUploaded": "Number of photos uploaded",
  "statsPage_photos": "photos",
  "statsPage_totalAmountProperties": "Total amount of properties",
  "statsPage_amountCompleted": "Amount completed",
  "statsPage_actionsPerVisitor": "Actions per visitor on the Widget",
  "statsPage_yourItems": "Your items",
  "statsPage_name": "Name",
  "statsPage_sku": "SKU",
  "statsPage_quantity": "Quantity",
  "statsPage_numberOfUnits": "Number of units",
  "statsPage_accessible": "Accessible",
  "statsPage_notAccessible": "Not accessible",
  "statsPage_unit": "Unit",
  "statsPage_amount": "Amount",
  "statsPage_incomplete": "Incomplete",
  "statsPage_completed": "Completed",
  "statsPage_notCompleted": "Not completed",
  "statsPage_mobility": "Mobility",
  "statsPage_cognitive": "Cognitive",
  "statsPage_hearing": "Hearing",
  "statsPage_visual": "Visual",
  "statsPage_allergy": "Allergy",
  "statsPage_class": "Class",
  "statsPage_totalAccessibilityDatapoints": "Total accessibility data points",
  "statsPage_visitorsThatOpened": "Visitors that opened the Widget",
  "statsPage_visitorsInteraction": "Total actions on the Widget",
  "statsPage_action": "Action",
  "statsPage_clicks": "Clicks",
  "statsPage_noDataAvailable_topText": "There is no data available",
  "statsPage_noDataAvailable_bottomText": "At The Moment",
  "statsPage_company_address": "Address",
  "statsPage_company_city": "City",
  "statsPage_company_country": "Country",
  "statsPage_company_name": "Name",
  "statsPage_company_type": "Type",
  "statsPage_company_registration_number": "Registration number",
  "statsPage_company_logo": "Logo",
  "statsPage_company_employees": "Employees",
  "statsPage_company_empty_fields": "Empty fields",
  "settingsPage_alertMsgImageUpload": "Click save to update your profile picture",
  "settingsPage_alertMsgCompanyInformation_1": "Contact",
  "settingsPage_alertMsgCompanyInformation_2": "Customer Support",
  "settingsPage_alertMsgCompanyInformation_3": "if you need to make changes to Company Information.",
  "documentationPage_downloadDocument": "Download document",
  "documentationPage_loadingDocument": "Loading document",
  "CLP_Status": "Status",
  "CLP_lastUpdate": "Last Update",
  "CLP_completed": "completed",
  "CLP_incomplete": "incomplete",
  "LanguagesDropdown_Languages": "Languages",
  "login_welcome_message": "Welcome to the Accessibility Management System 👋",
  "CLP_Checklist_is_generated_based": "The Checklist is generated based on the Accessibility Data that we collect from your property. It shows the areas of improvement and once you check off the point, the answer is automatically updated in the system and your accessibility data will be changed. The document can be downloaded for external use. For more information",
  "CLP_Go_to_checklist": "Go to checklist",
  "CLP_Updated_date": "Updated date",
  "CLP_The_purpose_of_Handiscover_1": "The purpose of Handiscover's inventory and checklist is to guide you as you improve your accessibility. The attached list consists of several items. From the perspective that something should be accessibility-adapted, there are points that are mandatory. In addition, we identify points such as we recommend whether to build new or renovates.",
  "CLP_List_points": "List points",
  "CLP_Priority": "Priority",
  "CLP_User": "User",
  "CLP_Mandatory": "Mandatory",
  "CLP_Need_help": "Need help? Contact our team",
  "CLP_Handiscovers_suggestions": "Handiscover's suggestions",
  "propertyForm_nextStep_tooltip": "Fill in all required fields first",
  "statsPage_See_photos": "See photos",
  "statsPage_Your_subscription": "Your subscription",
  "statsPage_Filter_data_from": "Filter data from",
  "statsPage_Filter_data_to": "Filter data to",
  "statsPage_to": "to",
  "statsPage_Reload": "Reload",
  "statsPage_Business_Metrics": "Business Metrics",
  "statsPage_Service_Metrics": "Service Metrics",
  "statsPage_Statistics_page": "Statistics page",
  "imagesPage_Pictures_List": "Pictures List",
  "imagesPage_Search_by_name": "Search by name",
  "imagesPage_No_pictures_available": "No pictures available",
  "imagesPage_Name": "Name",
  "imagesPage_Display_in_widget": "Display in widget",
  "imagesPage_Type": "Type",
  "imagesPage_Update_date": "Update date",
  "imagesPage_Mandatory": "Mandatory",
  "imagesPage_Are_your_sure": "Are your sure?",
  "imagesPage_Delete": "Delete",
  "imagesPage_Yes": "Yes",
  "imagesPage_Cancel": "Cancel",
  "imagesPage_Open_image": "Open image",
  "imagesPage_Edit": "Edit",
  "imagesPage_Delete_image": "Delete image",
  "CLP_The_purpose_of_Handiscover_2": "We have also included points that are \"Easy\" to fix but probably important from one accessibility perspective.",
  "a11yUnits_The_title_has_been_translated": "The title has been translated",
  "statsPage_Statistics": "Statistics",
  "customerSupportPage_thankYou": "Thank you!",
  "customerSupportPage_requestSuccessfully": "Your request has been sent successfully. Our Customer Support will take care of your request and get back to you as soon as possible.",
  "customerSupportPage_warning": "Warning",
  "customerSupportPage_error": "Error",
  "propertyListPage_showAll": "Show all",
  "propertyListPage_completed": "Completed",
  "propertyListPage_incomplete": "Incomplete",
  "dashboard": "Dashboard",
  "widget": "Widget",
  "property_type": "Property type",
  "category": "Category",
  "edit_widget": "Edit widget",
  "created": "Created",
  "published": "Published",
  "unpublished": "Unpublished",
  "widget_info": "The accessibility widget displays detailed accessibility data previously logged in the Accessibility Management System. This widget makes it possible to create better conditions for visitors to plan their stay in advance by seeing the accessibility available. The accessibility widget is interactive as all data updated in the system is played back in the widget.",
  "view_live_widget": "View live widget",
  "no_widget_data_message": "We don’t have widget data. Please contact our customer service team.",
  "image_list": "Image list",
  "language_setting": "Language setting",
  "history": "History",
  "select_accessibility_unit": "Select Accessibility Unit",
  "add_new_image": "Add New Image",
  "order": "Order",
  "image": "Image",
  "description": "Description",
  "accessibility_unit": "Accessibility Unit",
  "accessibility": "Accessibility",
  "displayed_in_widget": "Displayed in widget",
  "current_image": "Current image",
  "upload_new_picture": "Upload new picture",
  "image_description": "Image description",
  "image_order": "Image Order",
  "back_to_list": "Back to list",
  "no_picture": "No picture",
  "please_write_the_text_in": "Please write the text in",
  "yes_delete": "YES, DELETE",
  "delete_warning_text": "If you do this, the item will disappear from the Widget and the standard will be automatically updated reflecting the change.",
  "select_language_the_widget_provide": "Select language the widget provide",
  "changed_by": "Changed by",
  "activity": "Activity",
  "showing": "Showing",
  "of": "of",
  "items": "items",
  "questionnaire": "Questionnaire",
  "we_are_showing_followings": "We are showing followings in your Widget",
  "we_are_recommended_to_state": "We are recommended to state some practical information in the Widget for visitor to your property. If you would like to edit it, please contact our customer service",
  "select_what_you_want_to_show": "Select what you want to show in widget",
  "practical_information": "Practical information",
  "you_can_add_maximum": "You can add maximum 3 sentences",
  "for_the_best_experiences_in_widget": "For the best experiences in Widget, we will help you if you wish adding more information",
  "if_you_do_this_the_item_will_disappear": "If you do this, the item will disappear from the Widget",
  "you_can_write_free_texts": "You can write free texts to add to the general information if needed. Max 40 characters",
  "write_a_new_information": "Write a new information",
  "you_can_drag_and_drop_the_block": "You can drag and drop the block to change the orders. Please select the check box to present in the widget.",
  "you_can_freely_change_the_images_ordering": "You can freely change the images ordering by drag and drop.",
  "preview": "Preview",
  "add_point_on_map": "Add point on map",
  "LanguagesDropdown_Spanish": "Spanish",
  "LanguagesDropdown_Norwegian": "Norwegian",
  "LanguagesDropdown_Portuguese": "Portuguese",
  "LanguagesDropdown_Ukrainian": "Ukrainian",
  "main_unit_image": "Main unit image(s)",
  "item_pictures": "Item pictures",
  "please_choose_a_main_unit_image": "Please choose a Main Unit image",
  "please_choose_a_item_picture": "Please choose a Item picture",
  "button_settings_updated": 'The button settings have been successfully updated',
  "button_settings_created": "The button settings have been successfully created",
  "button_settings": "Button settings",
  "webmaster_instruction": "Webmaster instruction",
  "contract_has_expired": "Your contract has expired. The widget has been suspended. Contact support",
  "webmaster_instructions_are_not_available": "Webmaster instructions are not available at the moment. Contact support",
  "create_api_key": "Create API Key for this company",
  "standard_instruction": "Standard Instruction",
  "google_tag_manager_instruction": "Google Tag Manager Instruction"
}